import { render, staticRenderFns } from "./AthleteEditCommentDialog.vue?vue&type=template&id=355c9d9a&"
import script from "./AthleteEditCommentDialog.vue?vue&type=script&lang=ts&"
export * from "./AthleteEditCommentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports